<div class="p-3 mt-3 template-container">

  <h1>Default Template</h1>

  <div class="smp-title-large mb-3">Common panels</div>

  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          SMP Sample panel
        </mat-panel-title>
        <mat-panel-description>
          common inputs
        </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-form-field>
        <mat-label>"Input 1</mat-label>
        <input matInput>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Input 2</mat-label>
        <input matInput>
      </mat-form-field>
    </mat-expansion-panel>
    <mat-expansion-panel (opened)="panelOpenState = true"
                         (closed)="panelOpenState = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          State panel
        </mat-panel-title>
        <mat-panel-description>
          State is: {{panelOpenState ? 'open' : 'closed'}}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <p>Panel content</p>
      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
    </mat-expansion-panel>
    <mat-expansion-panel (opened)="panelOpenState2 = true"
                         (closed)="panelOpenState2 = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          State panel 2
        </mat-panel-title>
        <mat-panel-description>
          State is: {{panelOpenState2 ? 'open' : 'closed'}}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <p>Panel content 2</p>
      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
    </mat-expansion-panel>
  </mat-accordion>

  <hr>

  <div class="row">
    <div class="col-sm-4">
      <div class="smp-title-large">Common inputs</div>

      <dr-input-text></dr-input-text>

      <!-- TODO: Extract to component -->
      <div class="row">
        <div class="col-sm-10">
          <div class="row no-gutters">
            <mat-form-field class="full-width">
              <mat-label>Text one-line with icon</mat-label>
              <input type="text" matInput
                     [(ngModel)]="some"
              >
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-2">
          <button mat-raised-button style="margin-top: 5px;"><mat-icon>add</mat-icon></button>
        </div>
      </div>

      <dr-input-select></dr-input-select>
      <dr-input-textarea></dr-input-textarea>

      <div class="row">
        <div class="col-sm-5">
          <dr-checkbox [boolValue]="true"
                       [label]="'This is a boolean input'">
          </dr-checkbox>
        </div>
        <div class="col-sm-5">
          <dr-checkbox [boolValue]="false"
                       [label]="'And you can click the entire area'">
          </dr-checkbox>
        </div>
      </div>

      <div class="row" style="margin-top: 20px;">
        <div class="col-sm-10">
          <app-boolean-toggle [inputLabel]="'Label: true, false or unknown'"
                              [trueFalseNull]="null">
          </app-boolean-toggle>
        </div>
      </div>

      <div class="row" style="margin-top: 20px;">
        <div class="col-sm-10">
          <date-time-picker [date]="null"
                            [time]="null">
          </date-time-picker>
        </div>
      </div>

      <div class="row" style="margin-top: 20px;">
        <div class="col-sm-10">
          <div class="row no-gutters">
            <mat-form-field class="full-width">
              <mat-label>Currency</mat-label>
              <input type="text" matInput currency>
            </mat-form-field>
          </div>
        </div>
        <div class="col-2 align-self-center pl-3">
          {{ currency.currency_display_name }}
        </div>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="smp-title-large">Common buttons</div>

      <div class="row mt-3">
        <div class="col-sm-12">
          <button mat-raised-button class="full-width mat-accent">SMP-PRIMARY-FULLWIDTH</button>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <button mat-raised-button class="full-width margin-top-10">SMP-SECONDARY-FULLWIDTH</button>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-sm-6">
          <button mat-raised-button class="mat-accent">SMP-PRIMARY</button>
        </div>
        <div class="col-sm-6">
          <button mat-raised-button>SMP-SECONDARY</button>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-sm-6">
          <a mat-button>
            <span>SMP-NO BORDER</span>
          </a>
        </div>
        <div class="col-sm-6">

        </div>
      </div>

    </div>

    <div class="col-sm-4">
      <div class="smp-title-large">Icons</div>
      <div class="smp-title-thin-border mb-3">Material</div>
      <div class="row">
        <div class="col-sm-3">
          <button mat-icon-button>
            <mat-icon aria-label="Edit">create</mat-icon> Edit
          </button>
        </div>

        <div class="col-sm-3">
          <button mat-icon-button>
            <mat-icon aria-label="Search">search</mat-icon> Search
          </button>
        </div>

        <div class="col-sm-3">
          <button mat-icon-button>
            <mat-icon aria-label="Download">get_app</mat-icon> Download
          </button>
        </div>

        <div class="col-sm-3">
          <button mat-icon-button>
            <mat-icon aria-label="Download">add</mat-icon> More / details
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          <button mat-icon-button>
            <mat-icon aria-label="Delete">clear</mat-icon> Delete / remove
          </button>
        </div>

        <div class="col-sm-3">
          <button mat-icon-button>
            <mat-icon aria-label="Menu">menu</mat-icon> Menu
          </button>
        </div>

        <div class="col-sm-3">
          <button mat-icon-button>
            <mat-icon aria-label="Logout">exit_to_app</mat-icon> Logout
          </button>
        </div>

        <div class="col-sm-3">

        </div>
      </div>


      <div class="smp-title-thin-border mt-3">Font Awesome</div>
      <div class="row">
        <div class="col-sm-3">
          <i class="dr-fa-icon far fa-lg fa-file-image"></i>
          Image file
        </div>

        <div class="col-sm-3">
          <i class="dr-fa-icon far fa-lg fa-file-video"></i>
          Video file
        </div>

        <div class="col-sm-3">
          <i class="dr-fa-icon far fa-lg fa-file-audio"></i>
          Sound file
        </div>

        <div class="col-sm-3">
          <i class="dr-fa-icon far fa-lg fa-file-alt"></i>
          Txt file
        </div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          <i class="dr-fa-icon far fa-lg fa-file-word"></i>
          Word file
        </div>

        <div class="col-sm-3">
          <i class="dr-fa-icon far fa-lg fa-file-excel"></i>
          Excel file
        </div>

        <div class="col-sm-3">
          <i class="dr-fa-icon far fa-lg fa-file-powerpoint"></i>
          Ppt file
        </div>

        <div class="col-sm-3">
          <i class="dr-fa-icon far fa-lg fa-file-pdf"></i>
          Pdf file
        </div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          <i class="dr-fa-icon far fa-lg fa-file"></i>
          File
        </div>

        <div class="col-sm-3">
          <i class="dr-fa-icon fas fa-lg fa-eye"></i>
          View / show
        </div>

        <div class="col-sm-3">
          <i class="dr-fa-icon fas fa-lg fa-eye-slash"></i>
          Hide
        </div>

        <div class="col-sm-3">
          <i class="dr-fa-icon fas fa-lg fa-check"></i>
          Check
        </div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          <i class="dr-fa-icon fas fa-lg fa-ban"></i>
          Inactive / ...
        </div>

        <div class="col-sm-3">

        </div>

        <div class="col-sm-3">

        </div>

        <div class="col-sm-3">

        </div>
      </div>
    </div>
  </div>

  <div class="smp-title-large">File upload</div>
  <div class="row">
    <div class="col-sm-3">
      <div class="smp-title-thin-border mb-3">Dropzone with file list</div>
      <smp-dropzone class="full-width"
                    [label]="'Clickable custom text when empty'"
                    [acceptedFiles]="acceptedFileTypes"
                    [addButtonLabel]="'Clickable custom text when NOT empty'"
                    (filesSelected)="onFilesSelectedList($event)"
                    [hasContent]="fileMetaList1?.entries?.length > 0">

          <file-operation-list [fileMetaList]="fileMetaList1"
                               [withIconAvatars]="true"
                               (view)="demo($event)"
                               (download)="demo($event)"
                               (delete)="deleteFile1($event)">
          </file-operation-list>

      </smp-dropzone>
    </div>

    <div class="col-sm-3">
      <div class="smp-title-thin-border mb-3">File list</div>

      <file-operation-list *ngIf="fileMetaList1 && fileMetaList1.entries.length > 0"
                           [fileMetaList]="fileMetaList1"
                           [withIconAvatars]="true"
                           (view)="demo($event)"
                           (download)="demo($event)"
                           (delete)="deleteFile1($event)">
      </file-operation-list>

    </div>

    <div class="col-sm-3">
      <div class="smp-title-thin-border mb-3">Dropzone with Thumbnails (demo picture)</div>
      <smp-dropzone class="full-width"
                    [label]="'Clickable custom text when empty '"
                    [acceptedFiles]="acceptedFileTypes"
                    [addButtonLabel]="'Clickable custom text when NOT empty'"
                    (filesSelected)="onFilesSelectedThumbnail($event)" [hasContent]="fileMetaList2?.entries?.length > 0">

        <file-thumbnails-list [fileMetaList]="fileMetaList2"
                              [withIconAvatars]="true"
                              (view)="demo($event)"
                              (download)="demo($event)"
                              (delete)="deleteFile2($event)">
        </file-thumbnails-list>

      </smp-dropzone>

    </div>

    <div class="col-sm-3">
      <div class="smp-title-thin-border mb-3">Thumbnails (demo picture)</div>

      <file-thumbnails-list *ngIf="fileMetaList2 && fileMetaList2.entries.length > 0"
                            [fileMetaList]="fileMetaList2"
                            [withIconAvatars]="true"
                            (view)="demo($event)"
                            (download)="demo($event)"
                            (delete)="deleteFile2($event)">
      </file-thumbnails-list>

    </div>
  </div>

  <div class="smp-title-large mt-4">File select lists</div>
  <div class="row">
    <div class="col-sm-3">
      <div class="smp-title-thin-border mb-3">File select list - with dropzone</div>
      <smp-dropzone class="full-width"
                    [label]="'Clickable custom text when empty'"
                    [acceptedFiles]="acceptedFileTypes"
                    [addButtonLabel]="'Clickable custom text when NOT empty'"
                    (filesSelected)="onFilesSelectedList($event)" [hasContent]="fileMetaList1?.entries?.length > 0">

        <file-selection-list class="full-width"
                             [fileMetaList]="fileMetaList1"
                             [withIconAvatars]="true"
                             [selected]="selectedFiles"
                             (select)="selectFile($event)">
        </file-selection-list>

      </smp-dropzone>
    </div>

    <div class="col-sm-3">
      <div class="smp-title-thin-border mb-3">File select list</div>

      <file-selection-list class="full-width"
                           *ngIf="fileMetaList1 && fileMetaList1.entries.length > 0"
                           [fileMetaList]="fileMetaList1"
                           [withIconAvatars]="true"
                           [selected]="selectedFiles"
                           (select)="selectFile($event)">
      </file-selection-list>

    </div>

    <div class="col-sm-3">
      <div class="smp-title-thin-border mb-3">File select thumbnail list - with dropzone</div>
      <smp-dropzone class="full-width"
                    [label]="'Clickable custom text when empty '"
                    [acceptedFiles]="acceptedFileTypes"
                    [addButtonLabel]="'Clickable custom text when NOT empty'"
                    (filesSelected)="onFilesSelectedThumbnail($event)"
                    [hasContent]="fileMetaList2?.entries?.length > 0">

        <!-- only works with a dropzone. List is displayed inside the dropzone (if it has files) -->
        <file-selection-thumbnails-list class="full-width"
                                        [fileMetaList]="fileMetaList2"
                                        [selected]="selectedFiles"
                                        (select)="selectFile($event)">
        </file-selection-thumbnails-list>

      </smp-dropzone>
    </div>

    <div class="col-sm-3">
      <div class="smp-title-thin-border mb-3">File select thumbnail list</div>

      <!-- only works with a dropzone. List is displayed inside the dropzone (if it has files) -->
      <file-selection-thumbnails-list class="full-width"
                                      *ngIf="fileMetaList2 && fileMetaList2.entries.length > 0"
                                      [fileMetaList]="fileMetaList2"
                                      [selected]="selectedFiles"
                                      (select)="selectFile($event)">
      </file-selection-thumbnails-list>

    </div>
  </div>

  <div class="row">
    <div class="col-sm-3">
      <div class="smp-title-thin-border mb-3 mt-3">Selected files:</div>
      <tr *ngFor="let item of selectedFiles">
        {{ item.filename }}
      </tr>
    </div>
  </div>

</div>
